import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ChannelUpdateLog
 *
 * @property {number} id
 */
export class ChannelUpdateLog extends Model {


}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'transaction_id',
    'type',
    'is_success',
    'requested_at',
    'request_body',
    'responded_at',
    'response_body',
)(ChannelUpdateLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/channel-update-log.model.js